module.exports = __webpack_public_path__ + "logo_46-9fc4b123f6f9c84df7cc6055eb238c24.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_46.png
// module id = 1136
// module chunks = 0 1